import { supabaseClient } from "./client";

const BUCKET = "message-attachments";
const ALLOWED_EXTENSIONS = new Set(["pdf", "jpg", "jpeg", "png", "gif", "webp", "xlsx", "xls", "csv", "txt", "doc", "docx"]);
const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024; // 10 MB

export async function uploadAttachment(file, fromAirline) {
  const rawExt = file.name.includes(".") ? file.name.split(".").pop().toLowerCase() : "";
  if (!ALLOWED_EXTENSIONS.has(rawExt)) {
    throw new Error(`File type ".${rawExt}" is not allowed. Permitted types: PDF, images, Excel, CSV, Word, TXT.`);
  }
  if (file.size > MAX_ATTACHMENT_BYTES) {
    throw new Error("File is too large (max 10 MB).");
  }
  const path = `${fromAirline}/${Date.now()}-${Math.random().toString(36).slice(2)}.${rawExt}`;
  const { error } = await supabaseClient.storage.from(BUCKET).upload(path, file);
  if (error) { console.error("Attachment upload error", error); return null; }
  return path;
}

export async function getAttachmentUrl(path) {
  const { data, error } = await supabaseClient.storage.from(BUCKET).createSignedUrl(path, 3600);
  if (error || !data) return null;
  return data.signedUrl;
}

export async function downloadAttachmentBlob(path) {
  const { data, error } = await supabaseClient.storage.from(BUCKET).download(path);
  if (error || !data) return null;
  return data;
}

export async function deleteAttachment(path) {
  if (!path) return;
  await supabaseClient.storage.from(BUCKET).remove([path]);
}
